import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageService, SharedModule } from 'primeng/api';
import { GrowlService } from './services/growl.service';
import { environment } from '@environments/environment';
import { NgDompurifyModule } from '@tinkoff/ng-dompurify';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-growl',
    templateUrl: './growl.component.html',
    providers: [MessageService],
    standalone: true,
    imports: [ToastModule, SharedModule, NgDompurifyModule]
})
export class GrowlComponent implements OnInit, OnDestroy {
  msgs: any[] = [];
  subscription: Subscription;
  lifeTime: number;
  constructor(public growlService: GrowlService, public ref: ChangeDetectorRef, private messageService: MessageService) {}

  ngOnInit() {
    this.lifeTime = this.growlService.growlTimeout;
    this.subscribeToNotifications();
  }

  subscribeToNotifications() {
    this.subscription = this.growlService.notificationChange.subscribe(
      (notification: any) => {
        const dupeMsg = this.msgs.filter((m: any) => {
          return m.severity === notification.severity && m.summary === notification.summary && m.detail === notification.detail;
        });
        if (dupeMsg.length > 0) {
          clearTimeout(dupeMsg[0].timeout);
          dupeMsg[0].timeout = setTimeout(() => {
            this.msgs.splice(0, 1);
            this.ref.detectChanges();
            this.messageService.clear();
          }, dupeMsg[0].lifeTime);
        } else {
          // this.msgs = [];
          this.msgs.push(notification);
          this.messageService.add({key: 'globalToast', severity: notification.severity, summary: notification.summary, detail: notification.detail});
          notification.timeout = setTimeout(() => {
            this.msgs.splice(0, 1);
            this.ref.detectChanges();
            this.messageService.clear();
          }, notification.lifeTime);
        }
      }
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
